import * as React from 'react';
import { Button, Modal } from '../modules';

import ProductAvailabilityEmailForm from '../../components/ProductAvailabilityEmailForm';

import './modal.scss';

interface IAvailabilityWatchFormButtonProps {
  product: GQL.IProduct;
  variant: GQL.IProductVariant;
  whereOpened?: string;
  setCurrentProductAvailabityWatchdogForm?: (product?: GQL.IProduct, variant?: GQL.IProductVariant) => void;
}

interface IAvailabilityWatchFormButtonState {
  opened: boolean;
}

class AvailabilityWatchFormButton extends React.Component<
  IAvailabilityWatchFormButtonProps,
  IAvailabilityWatchFormButtonState
> {
  constructor(props: IAvailabilityWatchFormButtonProps) {
    super(props);

    this.state = {
      opened: false,
    };

    this.showEmailForm = this.showEmailForm.bind(this);
    this.hideEmailForm = this.hideEmailForm.bind(this);
  }

  public render() {
    return (
      <>
        <a
          onClick={() => {
            this.showEmailForm();
            if (this.props.setCurrentProductAvailabityWatchdogForm) {
              this.props.setCurrentProductAvailabityWatchdogForm(this.props.product, this.props.variant);
            }
            return false;
          }}
          href="#"
          className="watch-availability-button"
        >
          Watch availability
        </a>
        {(this.state.opened &&
          AvailabilityWatchFormButton.renderModal(
            true,
            this.props.product,
            this.props.variant,
            this.hideEmailForm,
            this.props.whereOpened,
          )) ||
          ''}
      </>
    );
  }

  public static renderModal(
    opened: boolean,
    product: GQL.IProduct,
    variant: GQL.IProductVariant,
    hideEmailForm?: () => void,
    whereOpened?: string,
  ) {
    return (
      <Modal
        open={opened}
        onClose={() => {
          if (hideEmailForm) {
            hideEmailForm();
          }
        }}
        type={whereOpened ? 'watchdog-email-form-in-' + whereOpened : 'watchdog-email-form'}
      >
        <button
          className="modal__close"
          onClick={() => {
            if (hideEmailForm) {
              hideEmailForm();
            }
          }}
        />
        <div className="watchdog-email-form-content">
          <ProductAvailabilityEmailForm
            afterSubmit={() => {
              if (hideEmailForm) {
                hideEmailForm();
              }
            }}
            product={product}
            variant={variant}
          />
        </div>
      </Modal>
    );
  }

  private showEmailForm() {
    // this.setState({opened: true}); // not used as this opens the form locally, not in the global modal
  }

  public hideEmailForm() {
    this.setState({ opened: false });
    if (this.props.setCurrentProductAvailabityWatchdogForm) {
      this.props.setCurrentProductAvailabityWatchdogForm();
    }
  }
}

export default AvailabilityWatchFormButton;



// WEBPACK FOOTER //
// ./src/modules/AvailabilityWatchFormButton/AvailabilityWatchFormButton.tsx